module.exports = __webpack_public_path__ + "img/52.d8b692e.jpg";